<div class="pts">
  @if (loading()) {
    <div class="pts__loading" data-testid="provider-tokens-loading">
      <mat-progress-spinner mode="indeterminate" diameter="32" />
    </div>
  } @else if (loadError()) {
    <p class="pts__error" role="alert">{{ 'providerTokens.loadError' | translate }}</p>
  } @else if (!hasSlots()) {
    <p class="pts__empty">{{ 'providerTokens.empty' | translate }}</p>
  } @else {
    @if (missingCount() > 0) {
      <div class="pts__banner" role="status" data-testid="provider-tokens-warning">
        <mat-icon class="pts__banner-icon" aria-hidden="true">shield</mat-icon>
        <span>{{ 'providerTokens.banner' | translate: { count: missingCount() } }}</span>
      </div>
    }

    <div class="pts__card">
      <div class="pts__head">
        <div class="pts__head-host">{{ 'providerTokens.col.host' | translate }}</div>
        <div class="pts__head-status">{{ 'providerTokens.col.status' | translate }}</div>
        <div class="pts__head-action"></div>
      </div>

      @for (row of rows(); track row.slot.providerType + '::' + row.slot.host; let last = $last) {
        <div
          class="pts__row"
          [class.pts__row--missing]="!row.slot.tokenSet"
          [class.pts__row--last]="last"
          data-testid="provider-token-row"
        >
          <div class="pts__row-head">
            <div class="pts__tile pts__tile--{{ providerLabel(row.slot.providerType) }}" aria-hidden="true">
              @if (row.slot.providerType === 'JIRA') {
                <i class="fa-brands fa-jira"></i>
              } @else if (row.slot.providerType === 'REDMINE') {
                <span class="pts__tile-label">RM</span>
              } @else {
                <i class="fa-brands fa-github"></i>
              }
            </div>

            <div class="pts__host-col">
              <div class="pts__host-line">
                <span class="pts__badge pts__badge--{{ providerLabel(row.slot.providerType) }}">
                  {{ 'providerTokens.provider.' + providerLabel(row.slot.providerType) | translate }}
                </span>
                <code class="pts__host">{{ row.slot.host }}</code>
              </div>
              <div class="pts__projects">
                {{
                  'providerTokens.projects'
                    | translate: { count: row.slot.projects.length, names: joinProjectNames(row.slot.projects) }
                }}
              </div>
            </div>

            <div class="pts__status">
              @if (row.slot.tokenSet) {
                <span class="pts__pill pts__pill--set">
                  <span class="pts__dot"></span>
                  {{ 'providerTokens.status.set' | translate }}
                </span>
                @if (row.slot.lastUsedAt) {
                  <small class="pts__meta">
                    {{ 'providerTokens.status.lastUsed' | translate: { when: row.slot.lastUsedAt | date: 'short' } }}
                  </small>
                }
              } @else {
                <span class="pts__pill pts__pill--missing">
                  <span class="pts__dot"></span>
                  {{ 'providerTokens.status.missing' | translate }}
                </span>
                <small class="pts__meta pts__meta--warning">
                  {{ 'providerTokens.status.blocked' | translate }}
                </small>
              }
            </div>

            <div class="pts__action-col">
              <button
                type="button"
                class="pts__action"
                [class.pts__action--set]="row.slot.tokenSet"
                [class.pts__action--missing]="!row.slot.tokenSet"
                [attr.aria-expanded]="row.expanded"
                (click)="toggleRow(row)"
              >
                {{ actionLabelKey(row) | translate }}
              </button>
            </div>
          </div>

          @if (row.expanded) {
            <div class="pts__expand">
              <div class="pts__expand-head">
                <mat-icon aria-hidden="true">vpn_key</mat-icon>
                {{ 'providerTokens.expand.title' | translate: { host: row.slot.host } }}
              </div>
              <div class="pts__expand-row">
                <label class="sr-only" [for]="'pts-input-' + row.slot.providerType + '-' + row.slot.host">
                  {{ 'providerTokens.expand.label' | translate }}
                </label>
                <input
                  [id]="'pts-input-' + row.slot.providerType + '-' + row.slot.host"
                  type="password"
                  data-testid="provider-token-input"
                  autocomplete="off"
                  class="pts__input"
                  [attr.placeholder]="
                    (row.slot.tokenSet
                      ? 'providerTokens.expand.placeholderRotate'
                      : 'providerTokens.expand.placeholder'
                    ) | translate
                  "
                  [value]="row.draft"
                  (input)="onDraftInput(row, $any($event.target).value)"
                />
                <button
                  type="button"
                  class="pts__save"
                  data-testid="provider-token-save"
                  [disabled]="!row.draft.trim() || row.busy"
                  (click)="save(row)"
                >
                  {{ 'providerTokens.expand.save' | translate }}
                </button>
                @if (row.slot.tokenSet) {
                  <button
                    type="button"
                    class="pts__delete"
                    data-testid="provider-token-delete"
                    [disabled]="row.busy"
                    (click)="remove(row)"
                  >
                    {{ 'providerTokens.expand.delete' | translate }}
                  </button>
                }
              </div>
              <div class="pts__expand-foot">
                <span>{{ providerHelpKey(row.slot.providerType) | translate }}</span>
                @if (row.slot.tokenSet && row.slot.rotatedAt) {
                  <span class="pts__rotated">
                    {{ 'providerTokens.expand.rotatedAt' | translate: { when: row.slot.rotatedAt | date: 'short' } }}
                  </span>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>

    <p class="pts__foot">
      <mat-icon aria-hidden="true">check_circle</mat-icon>
      <span>{{ 'providerTokens.footNote' | translate }}</span>
    </p>
  }
</div>
